import type { Client } from "../client";
import type { GitRefResource, ProjectResource } from "../resources";
import { BranchesRepository } from "./branchesRepository";
import { DeploymentProcessRepository } from "./deploymentProcessRepository";
import { DeploymentSettingsRepository } from "./deploymentSettingsRepository";
import { ProjectVariablesRepository } from "./projectVariableRepository";
export class ProjectContextRepository {
    DeploymentProcesses: DeploymentProcessRepository;
    DeploymentSettings: DeploymentSettingsRepository;
    Variables: ProjectVariablesRepository;
    Branches: BranchesRepository;
    constructor(client: Client, project: ProjectResource, gitRef: GitRefResource | undefined) {
        this.DeploymentProcesses = new DeploymentProcessRepository(client, project, gitRef);
        this.DeploymentSettings = new DeploymentSettingsRepository(client, project, gitRef);
        this.Variables = new ProjectVariablesRepository(client, project, gitRef);
        this.Branches = new BranchesRepository(client);
    }
}
